// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/TableOfContent/DropdownOfContent.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/TableOfContent/DropdownOfContent.tsx");
  import.meta.hot.lastModified = "1740183864613.0493";
}
// REMIX HMR END

import { Popover, Transition } from "@headlessui/react";
import { Fragment } from "react";
import clsx from "clsx";
import { Link } from "@remix-run/react";
import { useLockScroll } from "~/hooks/useLockScroll";
import { IconResolver } from "~/components";
import { formatTitleForTableOfContent } from "~/utils/utils";
export default function DropdownOfContent({
  links,
  activeSection
}) {
  var _s = $RefreshSig$();
  return <Popover as={"div"} className={({
    open
  }) => clsx("fixed w-full bg-white z-10 lg:hidden mt-[57px] md:mt-[89px]", open && "h-full")}>
            {_s(({
      open
    }) => {
      _s();
      useLockScroll(open);
      return <Fragment>
                        <Popover.Button className="px-4 py-3 border-y flex w-full border-y-neutral-400 text-neutral-500">
                            <span className="text-start text-sm text-ellipsis break-words whitespace-nowrap overflow-hidden">
                                {activeSection?.name || "In this article"}
                            </span>
                            <IconResolver token="chevron-down" className={clsx("w-5 h-5 ml-auto transition-transform duration-200 ease-in-out flex-shrink-0 text-neutral-400", open && "transform rotate-180")} />
                        </Popover.Button>
                        <Transition as={Fragment} enter="transition ease-out duration-200" enterFrom="transform opacity-0 translate-y-[-20px]" enterTo="transform opacity-100 translate-y-0" leave="transition ease-in duration-200" leaveFrom="transform opacity-100 translate-y-0" leaveTo="transform opacity-0 translate-y-[-20px]">
                            <Popover.Panel as="nav" className="overflow-auto h-[calc(100dvh-100px)]">
                                {links.map(section => {
              const hash = formatTitleForTableOfContent(section || "");
              return <Popover.Button as={Link} data-active={activeSection?.hash === hash} className={clsx("block py-2 px-4 text-neutral-600 text-sm", "data-[active=true]:bg-neutral-200", "data-[active=true]:relative", "data-[active=true]:before:absolute", "data-[active=true]:before:left-[0px]", "data-[active=true]:before:top-[0px]", "data-[active=true]:before:w-[2px]", "data-[active=true]:before:h-full", "data-[active=true]:before:bg-secondary-500")} key={section} to={`#${hash}`}>
                                            {section}
                                        </Popover.Button>;
            })}
                            </Popover.Panel>
                        </Transition>

                    </Fragment>;
    }, "gGYBJeOUciScIrBiPGaBNrk6HFs=", false, function () {
      return [useLockScroll];
    })}
        </Popover>;
}
_c = DropdownOfContent;
var _c;
$RefreshReg$(_c, "DropdownOfContent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;